import FeaturedArtists from './FeaturedArtists';

export default FeaturedArtists;
